export enum PPSContractStatus {
    csPrepare = 0,
    csActual = 1,
    csFreeze = 2,
    csLock = 3,
    csClose = 4,
    csInWork = -1,
    csDelete = 5
}